// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.usage {
  margin-top: 25px;
}

.mobileView {
  padding-left: 100px !important;
}

.disable-link {
  pointer-events: none !important;
  color: #707070;
}

.manage-userStyle {
  font-weight: bold;
}

.noProducts-style {
  margin-bottom: 18px;
  margin-left: 0px;
}

@media (max-width: 509.5px) {
  .efota-toggle-active, .efota-toggle {
    height: 66px;
  }
}
@media (max-width: 369.5px) {
  .efota-toggle-active, .efota-toggle {
    height: 86px;
  }
}
.disable {
  cursor: not-allowed;
}
.disable a {
  pointer-events: none;
  color: #c4c4c4;
}

p {
  min-height: 72px;
}

@media screen and (max-width: 300px) {
  .donut-chart-container {
    margin: 0;
  }
}
.chart-container {
  margin: 0 auto;
  margin-bottom: 30px;
  max-width: 320px;
  width: 100%;
}

.icon-alert {
  padding-right: 30px;
}

#chart {
  text-align: center;
}

.result-value {
  font-size: 30px;
  font-weight: bold;
  margin-bottom: 10px;
  margin-top: 40%;
}

.msg-content {
  background-color: hsl(150, 100%, 24%);
  color: white;
  padding: 30px 15px;
  margin-bottom: 10px;
}

.dashboard-tile,
.manage-tile {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  background: white;
  border: 1px solid #d2d2d2;
  float: left;
  margin: 0 10px 20px;
  overflow: hidden;
  padding: 20px 15px 0;
  padding-bottom: 86px;
  position: relative;
  width: calc(33.33% - 20px);
}
.dashboard-tile .dashboard-title,
.manage-tile .dashboard-title {
  font: 24px "Omnes-ATT-W02";
  margin-bottom: 20px;
}
.dashboard-tile .product-names,
.manage-tile .product-names {
  font-weight: bold;
}
.dashboard-tile.empty-product,
.manage-tile.empty-product {
  padding-bottom: 20px;
}
.dashboard-tile.empty-product .dashboard-title,
.manage-tile.empty-product .dashboard-title {
  margin-bottom: 0;
}

.manage-tile {
  padding-bottom: 20px;
}

.usage-bar {
  margin-bottom: 5px;
  margin-top: 10px;
}

div {
  border: 0px blue solid;
}

hr {
  margin: 20px 0;
}

h1,
h2 {
  margin: 30px 0;
}

.pad-bottom {
  margin-bottom: 20px;
}

.row-box {
  padding: 0 5px;
}

footer {
  border-radius: 0 0 8px 8px;
  border-top: 1px solid #d2d2d2;
  bottom: 0;
  height: 86px;
  padding: 20px 0;
  position: absolute;
  right: 0%;
  text-align: center;
  width: 100%;
}

.display-column {
  display: flex;
  flex-wrap: wrap;
}

section .text-link {
  margin: 15px 0;
}

.search-tile {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  background: white;
  border: 1px solid #d2d2d2;
  float: left;
  margin: 0 0 60px;
  overflow: hidden;
  padding: 20px;
  width: 100%;
}
.search-tile label {
  font: 24px "Omnes-ATT-W02";
}

form {
  padding: 0 15px;
}

.pad-class {
  margin-left: -15px;
  padding-right: 0;
  margin-bottom: 0px;
}

.text-field {
  padding-right: 20px;
}

.container-box h3, .container-box h4 {
  font: 24px "Omnes-ATT-W02";
}
.container-box h3.manageDeploymentMixedFans, .container-box h4.manageDeploymentMixedFans {
  font-size: 18px;
}
.container-box .dashboard-tile .dashboard-usage span {
  color: 1px solid #d2d2d2;
}
.container-box .dashboard-tile .dashboard-usage:last-of-type {
  margin-bottom: 30px;
}
.container-box .dashboard-tile .dashboard-usage:last-of-type hr {
  border: 0;
}

.modal-header {
  padding: 30px;
  position: relative;
}
.modal-header h2 {
  font-size: 30px;
  font-weight: normal;
  margin: 0 !important;
  padding: 0;
}

.modal-body {
  padding: 0 30px;
  position: relative;
  width: 100%;
  max-height: 300px;
  overflow: auto;
}
.modal-body p {
  margin-top: 0 !important;
}

.modal-footer {
  padding: 0 30px 30px;
  position: relative;
  width: 100%;
}

.mar-bottom {
  margin-bottom: 30px;
}
.mar-bottom:last-child {
  margin-bottom: 0;
}

.text-label {
  margin-bottom: 10px;
  display: block;
}

.btn-click {
  padding: 7px 20px 8px;
}

@media (max-width: 1024px) {
  div {
    margin-top: 60px;
  }
  .manage-tile,
  .search-tile {
    float: none;
    margin: auto auto 20px;
    max-width: 420px;
    padding-bottom: 20px;
    width: calc(100% - 30px) !important;
  }
  .search-tile {
    margin-bottom: 30px;
  }
  .pad-class {
    margin-bottom: 10px;
  }
  .dashboard-tile {
    float: none;
    margin: auto auto 20px;
    max-width: 420px;
    padding-bottom: 66px;
    width: calc(100% - 30px) !important;
  }
  h1 {
    margin-bottom: 30px;
    margin-top: 20px;
    margin-left: -80px;
  }
  h2 {
    margin-bottom: 20px;
    margin-left: -80px;
  }
  footer {
    border-top: 0;
    height: 66px;
    margin-bottom: 20px;
    padding: 0 20px;
    position: absolute;
    text-align: center;
    width: 100%;
  }
  footer button {
    margin-top: 20px;
  }
  .shop-btn-align {
    margin-top: 30px;
  }
}
@media (max-width: 1024px) and (max-width: 1024px) {
  .manage-product-btn-align {
    margin-top: 24px;
  }
  footer {
    border-top: 1px solid #d1d1d1;
    height: 24px;
    margin-bottom: 5px;
    padding: 0 20px;
    position: relative;
    text-align: center;
    width: 100%;
  }
  .dotted-border-mobile {
    border-top: 1px solid #d1d1d1;
  }
}
@media (max-width: 1024px) {
  .display-column {
    display: block;
  }
  .text-field {
    padding-right: 0;
  }
  .modal-footer button {
    width: 100%;
  }
  .container-box {
    margin-left: 100px;
  }
  .container-box .dashboard-tile .dashboard-usage:last-of-type {
    margin-bottom: 20px;
  }
  .container-box .dashboard-tile .dashboard-usage:last-of-type hr {
    border: 1px dotted;
  }
  .search-hr {
    margin: 10px 15px 20px;
  }
  form {
    padding: 0 5px;
  }
  .modal-header {
    padding: 15px;
    padding-bottom: 30px;
  }
  .modal-header h2 {
    font-size: 18px;
  }
  .modal-body {
    max-height: 145px;
    overflow: auto;
    padding: 0 15px;
  }
  .modal-footer {
    padding: 0 15px;
  }
  .modal-footer a {
    padding: 20px 0;
    width: 100%;
  }
}
h4 {
  font-size: 1.8rem;
}

.addp-dashboard-page h1 {
  margin-top: 30px;
}
.addp-dashboard-page .initial-text {
  font-size: 1.8rem;
}
.addp-dashboard-page .alert {
  margin-bottom: 20px;
}
.addp-dashboard-page .tab {
  width: 42%;
  overflow: hidden;
  background-color: #f1f1f1;
  border-radius: 6px;
  margin-bottom: 35px;
}
@media (max-width: 1024px) {
  .addp-dashboard-page .tab {
    width: 100%;
    overflow: hidden;
    background-color: #f1f1f1;
    border-radius: 6px;
    font-size: 6px;
    height: 20%;
  }
}
.addp-dashboard-page .tab button {
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
  font-size: 17px;
}
@media (min-width: 1025px) {
  .addp-dashboard-page .tab button {
    float: left;
    border: none;
    outline: none;
    cursor: pointer;
    padding: 14px 16px;
    transition: 0.3s;
    font-size: 17px;
  }
}
@media (min-width: 1025px) and (max-width: 1183px) {
  .addp-dashboard-page .tab button {
    font-size: 14px;
  }
}
.addp-dashboard-page .samsung-toggle-active {
  border-radius: 6px 0px 0px 6px;
  color: #f1f1f1;
  width: 50%;
  background-color: #0068ae;
}
.addp-dashboard-page .samsung-toggle {
  border-radius: 6px 0px 0px 6px;
  color: #0068ae;
  width: 50%;
}
.addp-dashboard-page .efota-toggle-active {
  border-radius: 0px 6px 6px 0px;
  color: #f1f1f1;
  width: 50%;
  background-color: #0068ae;
}
.addp-dashboard-page .efota-toggle {
  border-radius: 0px 6px 6px 0px;
  color: #0068ae;
  width: 50%;
}
.addp-dashboard-page .reportRequest {
  margin-top: 290px;
  text-align: center;
}
.addp-dashboard-page .reportRequestLarge {
  margin-top: 320px;
  text-align: center;
}
.addp-dashboard-page .changeRequestLarge {
  margin-top: 327px;
  margin-bottom: 30px;
  text-align: center;
}
.addp-dashboard-page .changeRequest {
  margin-top: 298px;
  text-align: center;
  margin-bottom: 29px;
}
.addp-dashboard-page .changeRequestLink {
  font-size: 16px;
}
.addp-dashboard-page #changeRequestDiv {
  text-align: center;
  margin: 19px;
}
.addp-dashboard-page #efota-legend-container {
  height: 299px;
}
.addp-dashboard-page #efota-account-legend-container {
  height: 357px;
}
.addp-dashboard-page #reportsCountDiv {
  margin-top: 111px;
  text-align: center;
}
@media (min-width: 1025px) and (max-width: 1057px) {
  .addp-dashboard-page .changeRequestLarge {
    margin-top: 320px;
  }
  .addp-dashboard-page .changeRequest {
    margin-top: 289px;
  }
}
@media (min-width: 1058px) and (max-width: 1072px) {
  .addp-dashboard-page .changeRequestLarge {
    margin-top: 347px;
  }
  .addp-dashboard-page .changeRequest {
    margin-top: 317px;
  }
}
@media (min-width: 1025px) and (max-width: 1155px) {
  .addp-dashboard-page .changeRequestLink {
    font-size: 11.25px !important;
  }
}
@media (min-width: 1025px) and (max-width: 1072px) {
  .addp-dashboard-page .reportRequestLarge {
    margin-top: 340px;
    text-align: center;
  }
  .addp-dashboard-page .reportRequest {
    margin-top: 309px;
  }
}
@media (min-width: 1025px) and (max-width: 1155px) {
  .addp-dashboard-page .reportCountLink {
    font-size: 11.25px !important;
  }
}
.addp-dashboard-page .reportCountLink {
  margin-left: 10px;
  font-size: 16px;
}
.addp-dashboard-page .count-circle {
  background-color: hsl(0, 66%, 49%);
  border: 1px solid hsl(0, 66%, 49%);
  border-radius: 50%;
  box-sizing: content-box;
  color: hsl(0, 0%, 95%);
  display: inline-block;
  font-size: 16px;
  height: 20px;
  margin-left: 10px;
  text-align: center;
  vertical-align: text-top;
  min-width: 20px;
  margin-top: -15px;
  margin-left: -15px;
}
@media (max-width: 1024px) {
  .addp-dashboard-page .efota-fan-status-container {
    width: 100%;
  }
}
.addp-dashboard-page .reportCount {
  margin-bottom: 20px;
  margin-left: 15px;
  margin-right: 15px;
}
.addp-dashboard-page .addp-dashboard-container, .addp-dashboard-page .addp-efota-container {
  margin-bottom: 60px;
}
.addp-dashboard-page .addp-dashboard-container .efota-container, .addp-dashboard-page .addp-efota-container .efota-container {
  margin-left: -15px;
}
@media (max-width: 1024px) {
  .addp-dashboard-page .addp-dashboard-container .efota-container, .addp-dashboard-page .addp-efota-container .efota-container {
    margin-left: 1px;
  }
}
.addp-dashboard-page .addp-dashboard-container.size-set, .addp-dashboard-page .addp-efota-container.size-set {
  height: 592px !important;
}
.addp-dashboard-page .addp-dashboard-container.size-set-1, .addp-dashboard-page .addp-efota-container.size-set-1 {
  height: 562px !important;
}
.addp-dashboard-page .addp-dashboard-container.size-set-2, .addp-dashboard-page .addp-efota-container.size-set-2 {
  height: 612px !important;
}
.addp-dashboard-page .addp-dashboard-container.size-set-3, .addp-dashboard-page .addp-efota-container.size-set-3 {
  height: 216px !important;
}
.addp-dashboard-page .addp-dashboard-container.height-set .dashboard-button-container, .addp-dashboard-page .addp-efota-container.height-set .dashboard-button-container {
  bottom: 0;
  position: absolute;
  width: 100%;
}
.addp-dashboard-page .addp-dashboard-container.height-set .col-md-size,
.addp-dashboard-page .addp-dashboard-container.height-set .container,
.addp-dashboard-page .addp-dashboard-container.height-set .inside-container, .addp-dashboard-page .addp-efota-container.height-set .col-md-size,
.addp-dashboard-page .addp-efota-container.height-set .container,
.addp-dashboard-page .addp-efota-container.height-set .inside-container {
  height: 100%;
}
.addp-dashboard-page .addp-dashboard-container .container, .addp-dashboard-page .addp-efota-container .container {
  border-radius: 10px;
  border-radius: 10px;
  border-radius: 10px;
  border-radius: 10px;
  border-radius: 10px;
  border: 1px solid #d2d2d2;
  margin: 0 auto;
  padding: 20px;
  margin-bottom: 50px;
}
.addp-dashboard-page .addp-dashboard-container .inside-container, .addp-dashboard-page .addp-efota-container .inside-container {
  position: relative;
}
.addp-dashboard-page .addp-dashboard-container .dashboard-error-box, .addp-dashboard-page .addp-efota-container .dashboard-error-box {
  margin-bottom: 20px;
}
.addp-dashboard-page .addp-dashboard-container .dashboard-button-container, .addp-dashboard-page .addp-efota-container .dashboard-button-container {
  border-top: 1px solid #d2d2d2;
  padding-top: 20px;
  position: relative;
  bottom: 0;
}
.addp-dashboard-page .addp-dashboard-container .dashboard-button-container .btn-default, .addp-dashboard-page .addp-efota-container .dashboard-button-container .btn-default {
  background: linear-gradient(to bottom, #fcfcfc 0%, hsl(0, 0%, 95%) 100%);
}
.addp-dashboard-page .addp-dashboard-container .dashboard-button-container button, .addp-dashboard-page .addp-efota-container .dashboard-button-container button {
  margin: 0;
  width: 100%;
}
@media screen and (min-width: 300px) {
  .addp-dashboard-page .addp-dashboard-container .donut-chart-container, .addp-dashboard-page .addp-efota-container .donut-chart-container {
    margin: 20px 20px 20px 0;
  }
}
.addp-dashboard-page .addp-dashboard-container .donut-chart-legend-container, .addp-dashboard-page .addp-efota-container .donut-chart-legend-container {
  margin-bottom: 20px;
  padding-left: 20px;
  min-height: 80px;
}
.addp-dashboard-page .addp-dashboard-container .donut-chart-legend-container-efota, .addp-dashboard-page .addp-efota-container .donut-chart-legend-container-efota {
  margin-bottom: 82px;
}
.addp-dashboard-page .addp-dashboard-container .legend-container, .addp-dashboard-page .addp-efota-container .legend-container {
  padding-left: 20px;
}
.addp-dashboard-page .addp-dashboard-container #first-time-user-notification, .addp-dashboard-page .addp-efota-container #first-time-user-notification {
  min-height: 72px;
}
.addp-dashboard-page .addp-dashboard-container .apple-cert, .addp-dashboard-page .addp-efota-container .apple-cert {
  margin-bottom: 20px;
  margin-top: 20px;
}
.addp-dashboard-page .addp-dashboard-container .apple-cert a, .addp-dashboard-page .addp-efota-container .apple-cert a {
  font-size: 1.4rem;
  line-height: 1.8rem;
}
.addp-dashboard-page .addp-dashboard-container .apple-cert div, .addp-dashboard-page .addp-efota-container .apple-cert div {
  position: relative;
}
.addp-dashboard-page .addp-dashboard-container .remove-account, .addp-dashboard-page .addp-efota-container .remove-account {
  margin-top: 0px;
  margin-bottom: -45px;
  border-top: 1px solid #d2d2d2;
  padding: 10px 0px 10px 0px;
}
.addp-dashboard-page .addp-dashboard-container .remove-account a, .addp-dashboard-page .addp-efota-container .remove-account a {
  font-size: 1.4rem;
  line-height: 1.8rem;
}
@media (max-width: 1024px) {
  .addp-dashboard-page .addp-dashboard-container .remove-account, .addp-dashboard-page .addp-efota-container .remove-account {
    margin: 0px 0px 0px 0px;
  }
}
.addp-dashboard-page .addp-dashboard-container .iconNI, .addp-dashboard-page .addp-dashboard-container .iconE, .addp-dashboard-page .addp-dashboard-container .iconP, .addp-dashboard-page .addp-dashboard-container .iconI, .addp-dashboard-page .addp-efota-container .iconNI, .addp-dashboard-page .addp-efota-container .iconE, .addp-dashboard-page .addp-efota-container .iconP, .addp-dashboard-page .addp-efota-container .iconI {
  font-size: 20px;
  margin: 0;
}
.addp-dashboard-page .addp-dashboard-container .iconNI, .addp-dashboard-page .addp-efota-container .iconNI {
  color: #ffb81e;
}
.addp-dashboard-page .addp-dashboard-container .iconE, .addp-dashboard-page .addp-efota-container .iconE {
  color: #cf2a2a;
}
.addp-dashboard-page .addp-dashboard-container .iconP, .addp-dashboard-page .addp-dashboard-container .iconI, .addp-dashboard-page .addp-efota-container .iconP, .addp-dashboard-page .addp-efota-container .iconI {
  color: #007a3e;
}
.addp-dashboard-page .addp-dashboard-container .flex-container, .addp-dashboard-page .addp-efota-container .flex-container {
  flex-direction: row;
  flex-direction: row;
  flex-direction: row;
  flex-direction: row;
  flex-direction: row;
  align-items: center;
  align-items: center;
  align-items: center;
  align-items: center;
  align-items: center;
  display: flex;
}
.addp-dashboard-page .addp-dashboard-container .show-mobile, .addp-dashboard-page .addp-efota-container .show-mobile {
  display: none;
}
.addp-dashboard-page .addp-dashboard-container .show-desktop, .addp-dashboard-page .addp-efota-container .show-desktop {
  display: inline-block;
}
@media (max-width: 1024px) {
  .addp-dashboard-page .addp-dashboard-container.height-set .dashboard-button-container, .addp-dashboard-page .addp-efota-container.height-set .dashboard-button-container {
    bottom: 0;
    position: absolute;
    width: 100%;
  }
  .addp-dashboard-page .addp-dashboard-container.height-set .col-md-size,
  .addp-dashboard-page .addp-dashboard-container.height-set .container,
  .addp-dashboard-page .addp-dashboard-container.height-set .inside-container, .addp-dashboard-page .addp-efota-container.height-set .col-md-size,
  .addp-dashboard-page .addp-efota-container.height-set .container,
  .addp-dashboard-page .addp-efota-container.height-set .inside-container {
    height: auto;
  }
  .addp-dashboard-page .addp-dashboard-container .initial-text, .addp-dashboard-page .addp-efota-container .initial-text {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
  }
  .addp-dashboard-page .addp-dashboard-container .col-md-size, .addp-dashboard-page .addp-efota-container .col-md-size {
    padding: 10px 15px;
  }
  .addp-dashboard-page .addp-dashboard-container .device-hide,
  .addp-dashboard-page .addp-dashboard-container .show-desktop, .addp-dashboard-page .addp-efota-container .device-hide,
  .addp-dashboard-page .addp-efota-container .show-desktop {
    display: none;
  }
  .addp-dashboard-page .addp-dashboard-container .show-mobile, .addp-dashboard-page .addp-efota-container .show-mobile {
    display: inline-block;
  }
}

@media screen and (max-width: 1025px) and (min-width: 300px) {
  .mobileView {
    padding-left: 0px !important;
  }
  .addp-dashboard-page {
    margin-left: -79px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/manage-dashboard/manage-dashboard.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AAlJA;EACE,gBAAA;AAoJF;;AAlJA;EACE,8BAAA;AAqJF;;AAnJA;EACE,+BAAA;EACA,cAAA;AAsJF;;AAnJA;EACC,iBAAA;AAsJD;;AApJA;EACA,mBAAA;EACA,gBAAA;AAuJA;;AArJA;EACE;IACE,YAAA;EAwJF;AACF;AArJA;EACE;IACE,YAAA;EAuJF;AACF;AApJA;EACE,mBAAA;AAsJF;AArJE;EACE,oBAAA;EAEA,cAAA;AAsJJ;;AAlJA;EACE,gBAAA;AAqJF;;AAlJA;EAEE;IACE,SAAA;EAoJF;AACF;AAjJA;EACE,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAmJF;;AAhJA;EACE,mBAAA;AAmJF;;AAhJA;EACE,kBAAA;AAmJF;;AA3IA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;AA8IF;;AA3IA;EACI,qCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AA8IJ;;AA3IA;;EFjDI,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEoDF,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,0BAAA;AAkJF;AAjJE;;EACE,0BAAA;EACA,mBAAA;AAoJJ;AAjJA;;EACE,iBAAA;AAoJF;AAjJE;;EACE,oBAAA;AAoJJ;AAnJI;;EACE,gBAAA;AAsJN;;AAlJA;EACI,oBAAA;AAqJJ;;AAlJA;EACE,kBAAA;EACA,gBAAA;AAqJF;;AAnJA;EACE,sBAAA;AAsJF;;AAnJA;EACE,cAAA;AAsJF;;AAnJA;;EAEE,cAAA;AAsJF;;AAnJA;EACE,mBAAA;AAsJF;;AAnJA;EACE,cAAA;AAsJF;;AAnJA;EACE,0BAAA;EACA,6BAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;AAsJF;;AAlJA;EACE,aAAA;EACA,eAAA;AAqJF;;AAjJE;EACE,cAAA;AAoJJ;;AAhJA;EFlII,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEoIF,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,WAAA;AAuJF;AAtJE;EACE,0BAAA;AAwJJ;;AApJA;EACE,eAAA;AAuJF;;AApJA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;AAuJF;;AApJA;EACE,mBAAA;AAuJF;;AAnJE;EACE,0BAAA;AAsJJ;AArJI;EACE,eAAA;AAuJN;AAjJM;EACE,wBAAA;AAmJR;AAhJI;EACE,mBAAA;AAkJN;AAjJO;EACC,SAAA;AAmJR;;AA5IA;EACE,aAAA;EACA,kBAAA;AA+IF;AA7IE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;EACA,UAAA;AA+IJ;;AA3IA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AA8IF;AA7IE;EACE,wBAAA;AA+IJ;;AA1IA;EACE,oBAAA;EACA,kBAAA;EACA,WAAA;AA6IF;;AA1IA;EACE,mBAAA;AA6IF;AA3IE;EACE,gBAAA;AA6IJ;;AA1IA;EACE,mBAAA;EACA,cAAA;AA6IF;;AA3IA;EACE,qBAAA;AA8IF;;AF1XI;EEgPF;IACE,gBAAA;EA8IF;EA5IA;;IAEE,WAAA;IACA,sBAAA;IACA,gBAAA;IACA,oBAAA;IACA,mCAAA;EA8IF;EA3IA;IACE,mBAAA;EA6IF;EA3IA;IACE,mBAAA;EA6IF;EA3IA;IACE,WAAA;IACA,sBAAA;IACA,gBAAA;IACA,oBAAA;IACA,mCAAA;EA6IF;EA1IA;IACE,mBAAA;IACA,gBAAA;IACA,kBAAA;EA4IF;EAzIA;IACE,mBAAA;IACA,kBAAA;EA2IF;EAxIA;IACE,aAAA;IACA,YAAA;IACA,mBAAA;IACA,eAAA;IACA,kBAAA;IACA,kBAAA;IACA,WAAA;EA0IF;EAxIE;IACE,gBAAA;EA0IJ;EAtID;IACI,gBAAA;EAwIH;AACF;AArIE;EACA;IACK,gBAAA;EAuIL;EArIA;IACE,6BAAA;IACA,YAAA;IACA,kBAAA;IACA,eAAA;IACA,kBAAA;IACA,kBAAA;IACA,WAAA;EAuIF;EApIA;IACG,6BAAA;EAsIH;AACF;AF9bI;EE2TF;IACE,cAAA;EAsIF;EAnIA;IACE,gBAAA;EAqIF;EAjIA;IACE,WAAA;EAmIF;EA/HF;IACE,kBAAA;EAiIA;EA/HE;IACE,mBAAA;EAiIJ;EAhIK;IACC,kBAAA;EAkIN;EA5HA;IACE,sBAAA;EA8HF;EA1HA;IACE,cAAA;EA4HF;EAzHA;IACE,aAAA;IACA,oBAAA;EA2HF;EAzHE;IACE,eAAA;EA2HJ;EAvHA;IACE,iBAAA;IACA,cAAA;IACA,eAAA;EAyHF;EAtHA;IACE,eAAA;EAwHF;EAtHE;IACE,eAAA;IACA,WAAA;EAwHJ;AACF;AApHA;EACE,iBAAA;AAsHF;;AA/GE;EACE,gBAAA;AAkHJ;AA/GE;EACE,iBAAA;AAiHJ;AA9GE;EACE,mBAAA;AAgHJ;AA7GE;EACE,UAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AA+GJ;AF/fI;EE2YF;IAOI,WAAA;IACA,gBAAA;IACA,yBAAA;IACA,kBAAA;IACA,cAAA;IACA,WAAA;EAiHJ;AACF;AA9GE;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAgHF;AF9gBI;EEuZF;IASE,WAAA;IACA,YAAA;IACA,aAAA;IACA,eAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;EAkHF;AACF;AA/GA;EACE;IACE,eAAA;EAiHF;AACF;AA9GE;EACE,8BAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;AAgHJ;AA7GE;EACE,8BAAA;EACA,cAAA;EACA,UAAA;AA+GJ;AA5GE;EACE,8BAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;AA8GJ;AA3GE;EACE,8BAAA;EACA,cAAA;EACA,UAAA;AA6GJ;AA1GE;EACE,iBAAA;EACA,kBAAA;AA4GJ;AAzGE;EACE,iBAAA;EACA,kBAAA;AA2GJ;AAxGE;EACE,iBAAA;EACA,mBAAA;EACA,kBAAA;AA0GJ;AAvGE;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;AAyGJ;AAtGE;EACE,eAAA;AAwGJ;AArGE;EACE,kBAAA;EACA,YAAA;AAuGJ;AApGE;EACE,aAAA;AAsGJ;AAnGE;EACE,aAAA;AAqGJ;AAlGE;EACE,iBAAA;EACA,kBAAA;AAoGJ;AAjGE;EACE;IACE,iBAAA;EAmGJ;EAjGE;IACE,iBAAA;EAmGJ;AACF;AA9FE;EACE;IACE,iBAAA;EAgGJ;EA9FE;IACE,iBAAA;EAgGJ;AACF;AA7FE;EACE;IACE,6BAAA;EA+FJ;AACF;AA1FE;EACE;IACE,iBAAA;IACA,kBAAA;EA4FJ;EA1FE;IACE,iBAAA;EA4FJ;AACF;AAzFE;EACE;IACE,6BAAA;EA2FJ;AACF;AAxFE;EACE,iBAAA;EACA,eAAA;AA0FJ;AAtFE;EACE,kCAAA;EACA,kCAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAwFJ;AFlpBI;EE8jBA;IACE,WAAA;EAuFJ;AACF;AApFE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;AAsFJ;AAnFE;EACE,mBAAA;AAqFJ;AAnFI;EACE,kBAAA;AAqFN;AFlqBI;EE4kBA;IAGI,gBAAA;EAuFN;AACF;AApFK;EACC,wBAAA;AAsFN;AApFI;EACE,wBAAA;AAsFN;AApFI;EACE,wBAAA;AAsFN;AApFI;EACE,wBAAA;AAsFN;AAnFM;EACE,SAAA;EACA,kBAAA;EACA,WAAA;AAqFR;AAlFM;;;;;EAGE,YAAA;AAsFR;AAjFI;EFlmBA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EEomBE,yBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;AAuFN;AApFI;EACE,kBAAA;AAsFN;AAnFI;EACE,mBAAA;AAqFN;AAlFI;EACE,6BAAA;EAEA,iBAAA;EACA,kBAAA;EACA,SAAA;AAmFN;AAlFM;EACE,wEAAA;AAoFR;AAlFM;EACE,SAAA;EACA,WAAA;AAoFR;AAhFI;EAGA;IACE,wBAAA;EAgFJ;AACF;AA5EI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AA8EN;AA1EI;EACE,mBAAA;AA4EN;AAzEI;EACE,kBAAA;AA2EN;AAxEI;EAEE,gBAAA;AAyEN;AArEI;EACE,mBAAA;EACA,gBAAA;AAuEN;AAtEM;EACE,iBAAA;EACA,mBAAA;AAwER;AAtEM;EACE,kBAAA;AAwER;AApEI;EACE,eAAA;EACA,oBAAA;EAKA,6BAAA;EACA,0BAAA;AAkEN;AAvEM;EACE,iBAAA;EACA,mBAAA;AAyER;AFrwBI;EEurBA;IAUI,uBAAA;EAwEN;AACF;AArEI;EACE,eAAA;EACA,SAAA;AAuEN;AApEI;EACE,cAAA;AAsEN;AAnEI;EACE,cAAA;AAqEN;AAlEI;EACE,cAAA;AAoEN;AAjEI;EF1sBA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EAAA,mBAAA;EE8sBE,aAAA;AA2EN;AAxEI;EACE,aAAA;AA0EN;AAvEI;EACE,qBAAA;AAyEN;AF3yBI;EEwuBI;IACE,SAAA;IACA,kBAAA;IACA,WAAA;EAsER;EAnEM;;;;;IAGE,YAAA;EAuER;EAnEI;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EAqEN;EAlEI;IACE,kBAAA;EAoEN;EAjEI;;;IAEE,aAAA;EAoEN;EAjEI;IACE,qBAAA;EAmEN;AACF;;AA9DA;EACE;IACE,4BAAA;EAiEF;EAhEE;IACE,kBAAA;EAkEJ;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","@import '../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n.usage {\n  margin-top: 25px;\n}\n.mobileView {\n  padding-left:100px !important;}\n\n.disable-link{\n  pointer-events: none !important;\n  color: #707070;\n}\n\n.manage-userStyle{\n font-weight: bold;\n}\n.noProducts-style{\nmargin-bottom:18px;\nmargin-left: 0px;\n}\n@media (max-width: 509.5px) {\n  .efota-toggle-active, .efota-toggle {\n    height: 66px;\n  }\n}\n\n@media (max-width: 369.5px) {\n  .efota-toggle-active, .efota-toggle {\n    height: 86px;\n  }\n}\n\n.disable {\n  cursor: not-allowed;\n  a {\n    pointer-events: none;\n    //cursor: not-allowed;\n    color: color(default, darker);\n  }\n}\n\np {\n  min-height: 72px;\n}\n\n@media screen and (max-width: 300px)   {\n\n  .donut-chart-container {\n    margin: 0;\n\n  }\n}\n.chart-container {\n  margin: 0 auto;\n  margin-bottom: 30px;\n  max-width: 320px;\n  width: 100%;\n}\n\n.icon-alert {\n  padding-right: 30px;\n}\n\n#chart {\n  text-align: center;\n}\n\n//p {\n//  margin: 0 auto;\n//  width: 70%;\n//}\n\n.result-value {\n  font-size: 30px;\n  font-weight: bold;\n  margin-bottom: 10px;\n  margin-top: 40%;\n}\n\n.msg-content {\n    background-color: color(success, base);\n    color: color(default, light);\n    padding: 30px 15px;\n    margin-bottom: 10px;\n  }\n\n.dashboard-tile,\n.manage-tile {\n  @include vendor-prefix('border-radius', 8px);\n  background: color(default, light);\n  border: 1px solid color(default, dark);\n  float: left;\n  margin: 0 10px 20px;\n  overflow: hidden;\n  padding: 20px 15px 0;\n  padding-bottom: 86px;\n  position: relative;\n  width: calc(33.33% - 20px);\n  .dashboard-title {\n    font: 24px 'Omnes-ATT-W02';\n    margin-bottom: 20px;\n  }\n\n.product-names{\n  font-weight:bold;\n  }\n\n  &.empty-product {\n    padding-bottom: 20px;\n    .dashboard-title {\n      margin-bottom: 0;\n    }\n  }\n}\n.manage-tile {\n    padding-bottom: 20px;\n}\n\n.usage-bar {\n  margin-bottom: 5px;\n  margin-top: 10px;\n}\ndiv {\n  border: 0px blue solid;\n}\n\nhr {\n  margin: 20px 0;\n}\n\nh1,\nh2 {\n  margin: 30px 0;\n}\n\n.pad-bottom {\n  margin-bottom: 20px;\n}\n\n.row-box {\n  padding: 0 5px;\n}\n\nfooter {\n  border-radius: 0 0 8px 8px;\n  border-top: 1px solid color(default, dark);\n  bottom: 0;\n  height: 86px;\n  padding: 20px 0;\n  position: absolute;\n  right: 0%;\n  text-align: center;\n  width: 100%;\n}\n\n\n.display-column {\n  display: flex;\n  flex-wrap: wrap;\n}\n\nsection {\n  .text-link {\n    margin: 15px 0;\n    }\n}\n\n.search-tile {\n  @include vendor-prefix('border-radius', 8px);\n  background: color(default, light);\n  border: 1px solid color(default, dark);\n  float: left;\n  margin: 0 0 60px;\n  overflow: hidden;\n  padding: 20px;\n  width: 100%;\n  label {\n    font: 24px 'Omnes-ATT-W02';\n  }\n}\n\nform {\n  padding: 0 15px;\n}\n\n.pad-class {\n  margin-left: -15px;\n  padding-right: 0;\n  margin-bottom: 0px;\n}\n\n.text-field {\n  padding-right: 20px;\n}\n\n.container-box {\n  h3,h4 {\n    font: 24px 'Omnes-ATT-W02';\n    &.manageDeploymentMixedFans {\n      font-size: 18px;\n    }\n  }\n\n  .dashboard-tile {\n    .dashboard-usage {\n      span {\n        color: 1px solid color(default, dark);\n      }\n    }\n    .dashboard-usage:last-of-type {\n      margin-bottom: 30px;\n       hr {\n        border: 0;\n        }\n    }\n}\n}\n\n\n.modal-header {\n  padding: 30px;\n  position: relative;\n\n  h2 {\n    font-size: 30px;\n    font-weight: normal;\n    margin: 0 !important;\n    padding: 0;\n   }\n  }\n\n.modal-body {\n  padding: 0 30px;\n  position: relative;\n  width: 100%;\n  max-height: 300px;\n  overflow: auto;\n  p {\n    margin-top: 0 !important;\n  }\n\n}\n\n.modal-footer {\n  padding: 0 30px 30px;\n  position: relative;\n  width: 100%;\n}\n\n.mar-bottom {\n  margin-bottom: 30px;\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n.text-label {\n  margin-bottom: 10px;\n  display: block;\n}\n.btn-click {\n  padding: 7px 20px 8px;\n}\n\n@include respond-to (small) {\n  div {\n    margin-top: 60px;\n  }\n  .manage-tile,\n  .search-tile {\n    float: none;\n    margin: auto auto 20px;\n    max-width: 420px;\n    padding-bottom: 20px;\n    width: calc(100% - 30px) !important;\n  }\n\n  .search-tile {\n    margin-bottom: 30px;\n  }\n  .pad-class {\n    margin-bottom: 10px;\n  }\n  .dashboard-tile {\n    float: none;\n    margin: auto auto 20px;\n    max-width: 420px;\n    padding-bottom: 66px;\n    width: calc(100% - 30px) !important;\n  }\n\n  h1 {\n    margin-bottom: 30px;\n    margin-top: 20px;\n    margin-left: -80px;\n  }\n\n  h2 {\n    margin-bottom: 20px;\n    margin-left: -80px;\n  }\n\n  footer {\n    border-top: 0;\n    height: 66px;\n    margin-bottom: 20px;\n    padding: 0 20px;\n    position: absolute;\n    text-align: center;\n    width: 100%;\n\n    button {\n      margin-top: 20px;\n    }\n  }\n\n .shop-btn-align {\n     margin-top: 30px;\n    // margin-top: 57px;\n  }\n\n  @media (max-width: 1024px){\n  .manage-product-btn-align{\n       margin-top: 24px;\n  }\n  footer{\n    border-top: 1px solid #d1d1d1;\n    height: 24px;\n    margin-bottom: 5px;\n    padding: 0 20px;\n    position: relative;\n    text-align: center;\n    width: 100%;\n}\n\n  .dotted-border-mobile{\n     border-top:1px solid #d1d1d1;\n  }\n  }\n\n  .display-column {\n    display: block;\n }\n\n  .text-field {\n    padding-right: 0;\n }\n\n.modal-footer {\n  button {\n    width: 100%;\n }\n}\n\n.container-box {\n  margin-left: 100px;\n  .dashboard-tile {\n    .dashboard-usage:last-of-type {\n      margin-bottom: 20px;\n       hr {\n        border:1px dotted;\n        }\n    }\n}\n}\n\n  .search-hr {\n    margin: 10px 15px 20px;\n\n}\n\n  form {\n    padding: 0 5px;\n  }\n\n  .modal-header {\n    padding: 15px;\n    padding-bottom: 30px;\n\n    h2 {\n      font-size: 18px;\n    }\n  }\n\n  .modal-body {\n    max-height: 145px;\n    overflow: auto;\n    padding: 0 15px;\n  }\n\n  .modal-footer {\n    padding: 0 15px;\n\n    a {\n      padding: 20px 0;\n      width: 100%;\n    }\n  }\n}\n\nh4 {\n  font-size: 1.8rem;\n}\n\n// ADDP section starts here\n.addp-dashboard-page {\n  //margin-left: 100px;\n\n  h1 {\n    margin-top: 30px;\n  }\n\n  .initial-text{\n    font-size: 1.8rem;\n  }\n\n  .alert {\n    margin-bottom: 20px;\n  }\n\n  .tab { \n    width: 42%;\n    overflow: hidden;\n    background-color: #f1f1f1;\n    border-radius: 6px;\n    margin-bottom: 35px;\n    @include respond-to (small) {\n      width: 100%;\n      overflow: hidden;\n      background-color: #f1f1f1;\n      border-radius: 6px;\n      font-size: 6px;\n      height: 20%;\n  }\n  }\n  \n  .tab button {\n  float: left;\n  border: none;\n  outline: none;\n  cursor: pointer;\n  padding: 14px 16px;\n  transition: 0.3s;\n  font-size: 17px;\n  @include respond-to ('large') {\n    float: left;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    padding: 14px 16px;\n    transition: 0.3s;\n    font-size: 17px;\n}\n}\n\n@media (min-width: 1025px) and (max-width: 1183px) {\n  .tab button {\n    font-size: 14px;\n  }\n}\n\n  .samsung-toggle-active {\n    border-radius: 6px 0px 0px 6px;\n    color: #f1f1f1;\n    width: 50%;\n    background-color: #0068ae;\n  }  \n\n  .samsung-toggle {\n    border-radius: 6px 0px 0px 6px;\n    color: #0068ae;\n    width: 50%;\n  }\n\n  .efota-toggle-active {\n    border-radius: 0px 6px 6px 0px;\n    color: #f1f1f1;\n    width: 50%;\n    background-color: #0068ae;\n  }\n\n  .efota-toggle {\n    border-radius: 0px 6px 6px 0px;\n    color: #0068ae;\n    width: 50%;\n  }\n\n  .reportRequest {\n    margin-top: 290px;\n    text-align: center;\n  }\n\n  .reportRequestLarge {\n    margin-top: 320px;\n    text-align: center;\n  }\n\n  .changeRequestLarge {\n    margin-top: 327px;\n    margin-bottom: 30px;\n    text-align: center;\n  }\n\n  .changeRequest {\n    margin-top: 298px;\n    text-align: center;\n    margin-bottom: 29px;\n  }\n\n  .changeRequestLink {\n    font-size: 16px;\n  }\n\n  #changeRequestDiv {\n    text-align: center;\n    margin: 19px;\n  }\n\n  #efota-legend-container{\n    height: 299px;\n  }\n\n  #efota-account-legend-container{\n    height: 357px;\n  }\n\n  #reportsCountDiv{\n    margin-top: 111px; \n    text-align: center;\n  }\n\n  @media (min-width: 1025px) and (max-width: 1057px) {\n    .changeRequestLarge {\n      margin-top: 320px;\n    }\n    .changeRequest {\n      margin-top: 289px;\n    }\n  }\n\n  \n\n  @media (min-width: 1058px) and (max-width: 1072px) {\n    .changeRequestLarge {\n      margin-top: 347px;\n    }\n    .changeRequest {\n      margin-top: 317px;\n    }\n  }\n\n  @media (min-width: 1025px) and (max-width: 1155px) {\n    .changeRequestLink {\n      font-size: 11.25px !important;\n    }\n  }\n\n  \n\n  @media (min-width: 1025px) and (max-width: 1072px) {\n    .reportRequestLarge {\n      margin-top: 340px;\n      text-align: center;\n    }\n    .reportRequest {\n      margin-top: 309px;\n    }\n  }\n\n  @media (min-width: 1025px) and (max-width: 1155px) {\n    .reportCountLink {\n      font-size: 11.25px !important;\n    }\n  }\n\n  .reportCountLink {\n    margin-left: 10px;\n    font-size: 16px;\n    \n  }\n\n  .count-circle {\n    background-color: color(danger, base);\n    border: 1px solid color(danger, base);\n    border-radius: 50%;\n    box-sizing: content-box;\n    color: color(default, base);\n    display: inline-block;\n    font-size: 16px;\n    height: 20px;\n    margin-left: 10px;\n    text-align: center;\n    vertical-align: text-top;\n    min-width: 20px;\n    margin-top: -15px;\n    margin-left: -15px;\n  }\n\n  @include respond-to (small) {\n    .efota-fan-status-container {\n      width: 100%;\n    }\n  }\n\n  .reportCount {\n    margin-bottom: 20px;\n    margin-left: 15px;\n    margin-right: 15px;\n  }\n\n  .addp-dashboard-container, .addp-efota-container {\n    margin-bottom: 60px;\n\n    .efota-container {\n      margin-left: -15px;\n    @include respond-to (small) {\n        margin-left: 1px;\n    }\n    }\n\n     &.size-set{\n      height:592px !important;\n    }\n    &.size-set-1{\n      height:562px !important;\n    }\n    &.size-set-2{\n      height:612px !important;\n    }\n    &.size-set-3{\n      height:216px !important;\n    }\n    &.height-set {\n      .dashboard-button-container {\n        bottom: 0;\n        position: absolute;\n        width: 100%;\n      }\n\n      .col-md-size,\n      .container,\n      .inside-container {\n        height: 100%;\n        // height: auto;\n      }\n    }\n\n    .container {\n      @include vendor-prefix('border-radius', 10px);\n      border: 1px solid color(default, dark);\n      margin: 0 auto;\n      padding: 20px;\n      margin-bottom: 50px;\n    }\n\n    .inside-container {\n      position: relative;\n    }\n\n    .dashboard-error-box {\n      margin-bottom: 20px;\n    }\n\n    .dashboard-button-container {\n      border-top: 1px solid color(default, dark);\n\n      padding-top: 20px;\n      position: relative;\n      bottom: 0;\n      .btn-default {\n        background: linear-gradient(to bottom, #fcfcfc 0%, color(default,base) 100%);\n      }\n      button {\n        margin: 0;\n        width: 100%;\n      }\n    }\n\n    @media screen and (min-width: 300px)   {\n\n\n    .donut-chart-container {\n      margin: 20px 20px 20px 0;\n    }\n\n  }\n\n    .donut-chart-legend-container {\n      margin-bottom: 20px;\n      padding-left: 20px;\n      min-height: 80px;\n\n    }\n\n    .donut-chart-legend-container-efota {\n      margin-bottom: 82px;\n    }\n\n    .legend-container{\n      padding-left: 20px;\n    }\n\n    #first-time-user-notification {\n\n      min-height: 72px;\n\n    }\n\n    .apple-cert {\n      margin-bottom: 20px;\n      margin-top: 20px;\n      a {\n        font-size: 1.4rem;\n        line-height: 1.8rem;\n      }\n      div {\n        position: relative;\n      }\n    }\n\n    .remove-account {\n      margin-top: 0px;\n      margin-bottom: -45px;\n      a {\n        font-size: 1.4rem;\n        line-height: 1.8rem;\n      }\n      border-top: 1px solid #d2d2d2;\n      padding: 10px 0px 10px 0px;\n      @include respond-to(small) {\n        margin: 0px 0px 0px 0px;\n      }\n    }\n\n    .iconNI, .iconE, .iconP, .iconI {\n      font-size: 20px;\n      margin: 0;\n    }\n\n    .iconNI {\n      color: #ffb81e;\n    }\n\n    .iconE {\n      color: #cf2a2a;\n    }\n\n    .iconP, .iconI {\n      color: #007a3e;\n    }\n\n    .flex-container {\n      @include vendor-prefix('flex-direction', row);\n      @include vendor-prefix('align-items', center);\n      display: -webkit-flex;\n      display: flex;\n    }\n\n    .show-mobile {\n      display: none;\n    }\n\n    .show-desktop {\n      display: inline-block;\n    }\n\n    @include respond-to (small) {\n\n      &.height-set {\n        .dashboard-button-container {\n          bottom: 0;\n          position: absolute;\n          width: 100%;\n        }\n\n        .col-md-size,\n        .container,\n        .inside-container {\n          height: auto;\n        }\n     }\n\n      .initial-text {\n        font-size: 14px;\n        font-weight: bold;\n        margin-bottom: 0;\n      }\n\n      .col-md-size {\n        padding: 10px 15px;\n      }\n\n      .device-hide,\n      .show-desktop {\n        display: none;\n      }\n\n      .show-mobile {\n        display: inline-block;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 1025px) and (min-width: 300px)  {\n  .mobileView {\n    padding-left:0px !important;}\n    .addp-dashboard-page {\n      margin-left: -79px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
